export default {
	data(){
		return {
			//beneficiarios
			beneficiariosItems: [
				{
					thead: {th: "Documento"},
					tbody: {td: ["id_list_documento","documento"], col: [4,8] }
				},
				{
					thead: {th: "Nombres"},
					tbody: {td: ["name"] }
				},
				{
					thead: {th: "Servicios", style: "width: 130px"},
					tbody: {td: ["servicios"] }
				},
				{
					thead: {th: "F. nacimiento"},
					tbody: {td: ["nacimiento"] }
				},
			],
			beneficiariosInits: [],
			//documentos
				documentosSearch: ['datos_afiliado/name'],				
				documentosItems: [
					{
						thead: { th: 'Titular', sort: null, sortTable: 'datos_afiliado/name'},
						tbody: { td: ['datos_afiliado/name'],}
					},
					{
						thead: { th: 'Nombre Documento', sort: null, sortTable: 'afiliado_documentos/name'},
						tbody: { td: ['afiliado_documentos/name'],}
					},
					{
						thead: { th: 'Archivo', },
						tbody: { td: ['afiliado_documentos/archivo'], link:'/files', archivo: true}
					},
					{
						thead: { th: 'Radicador', },
						tbody: { td: ['list_users/name'],}
					},
				],				
			//inclusiones
				tableGBHISTSearch: ['datos_afiliado/name','afiliado_beneficiarios/name'],				
				tableGBHISTItems: [
					{
					  thead: { th: 'Documento'},
					  tbody: { td: ['list_documento/name','afiliado_beneficiarios/documento'],}
					},
					{
						thead: { th: 'Beneficiario', sort: null, sortTable: 'afiliado_beneficiarios/name'},
						tbody: { td: ['afiliado_beneficiarios/name'],}
					},
					{
						thead: { th: 'Nacimiento', },
						tbody: { td: ['afiliado_beneficiarios/nacimiento'],}
					},
					{
					  thead: { th: 'Servicios', },
					  tbody: { td: ['afiliado_beneficiarios/servicios'], ftn: function (items) { let servicios= JSON.parse(items);let name=''; for (let i = 0; i < servicios.length; i++) {
						name = name+' '+servicios[i].name;                    
					  } return name} }
					},
					{
						thead: { th: 'Radicador', },
						tbody: { td: ['list_users/name'],}
					},
				],
			// afiliaciones

				afiliacionesSearch: ['info_ingresos/documento','info_ingresos/name'],
				
				afiliacionesItems: [
					{
						thead: { th: 'Documento', sort: null, sortTable: 'info_ingresos/documento'},
						tbody: { td: ['info_ingresos/documento',]}
					},
					{
						thead: { th: 'Nombre', sort: null, sortTable: 'info_ingresos/name'},
						tbody: { td: ['info_ingresos/name'],}
					},
					{
						thead: { th: 'Asesor', },
						tbody: { td: ['datos_asesor/name'],}
					},
					{
						thead: { th: 'Fecha', },
						tbody: { td: ['info_ingresos/fecha'],}
					},
					{
						thead: { th: 'Valor', },
						tbody: { td: ['info_ingresos/valor']}
					},
					{
						thead: { th: 'Reporte', },
						tbody: { td: ['info_ingresos/reporte']}
					},
					{
						thead: { th: 'Forma', },
						tbody: { td: ['list_forma/name']}
					},
					{
						thead: { th: 'Cuenta', },
						tbody: { td: ['list_cuentas/name','info_ingresos/consignacion'], show: {td: 'info_ingresos/id_list_forma', compare: 1, else: ''}}
					},
					{
						thead: { th: 'Registro', },
						tbody: { td: ['info_ingresos/id'], link: '/api/pdf/registro', show: {td: 'info_ingresos/anulado', compare: 0, else: 'Anulado'}}
					},
				],		
			// aportes

				aportesSearch: ['list_mes/name'],
				
				aportesItems: [
					{
						thead: { th: 'Razón', sort: null, sortTable: 'datos_razon/name'},
						tbody: { td: ['datos_razon/name'],}
					},
					{
						thead: { th: 'Fecha', },
						tbody: { td: ['info_aportes/fecha'],}
					},
					{
						thead: { th: 'Asesor', },
						tbody: { td: ['datos_asesor/name'],}
					},
					{
						thead: { th: 'Novedad'},
						tbody: { td: ['list_novedad/name']}
					},
					{
						thead: { th: 'Valor', },
						tbody: { td: ['info_aportes/valor']}
					},
					{
						thead: { th: 'Forma', },
						tbody: { td: ['list_forma/name']}
					},
					{
						thead: { th: 'Cuenta', },
						tbody: { td: ['list_cuentas/name','info_aportes/consignacion'], show: {td: 'info_aportes/id_list_forma', compare: 1, else: ''}}
					},
					{
						thead: { th: 'Periodo', },
						tbody: { td: ['list_mes/name','list_ano/name']}
					},
					{
						thead: { th: 'Registro', },
						tbody: { td: ['info_aportes/id'], link: '/api/pdf/registroaportes', show: {td: 'info_aportes/anulado', compare: 0, else: 'Anulado'}}
					},
				],				
		}
	},
}